import React from 'react'
import PropTypes from 'prop-types'
import EventHeaderDefault from './EventHeaderDefault'
import EventHeaderPrisma from './EventHeaderPrisma'
import { hasPartialServiceAccessTier } from 'hooks/useHasPermission'
import EventDetailsAccordion from './EventDetailsAccordion'

export default function EventHeader({
  event,
  crEvent = null,
  isLoading = false,
  showActiveBadge = true,
  children = null,
  classes,
  renderMenu,
}) {
  const hasPrismaAccess = hasPartialServiceAccessTier()

  if (!event) return null

  return (
    <>
      <header className={`event-header p-0 ${classes}`}>
        {hasPrismaAccess || event.category === 'product' ? (
          <EventHeaderPrisma event={event} showActiveBadge={showActiveBadge} renderMenu={renderMenu}>
            {children}
          </EventHeaderPrisma>
        ) : (
          <EventHeaderDefault event={event} showActiveBadge={showActiveBadge} renderMenu={renderMenu}>
            {children}
          </EventHeaderDefault>
        )}
      </header>

      <EventDetailsAccordion eventInfo={event} crEvent={crEvent} isLoading={isLoading} />
    </>
  )
}

EventHeader.propTypes = {
  event: PropTypes.object.isRequired,
  crEvent: PropTypes.object,
  isLoading: PropTypes.bool,
  menuOptions: PropTypes.array,
  showActiveBadge: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.string,
  renderMenu: PropTypes.func,
}
